import axios from 'axios'

import { handleErrorAndGenerateMessage } from '../../../functions/errorHandling'
import { getServerUrl } from '../../../functions/getServerUrl'

const defaultState = {
  fetchingAdverseEvents: false,
  editingAdverseEvent: false,
  fetchingAdverseEventHistory: false,
  adverseEvents: [],
  selectedAdverseEvent: null,
  adverseEventHistory: [],
}


export default function adverseEventsReducer(state = defaultState, action) {
  switch (action.type) {
    case "FETCHING_ADVERSE_EVENTS_FOR_PHARMA_VIGILANCE":
      return { ...state, fetchingAdverseEvents: true }
    case "SET_ADVERSE_EVENTS_FOR_PHARMA_VIGILANCE":
      return { ...state, fetchingAdverseEvents: false, adverseEvents: action.payload }
    case "SET_SELECTED_ADVERSE_EVENT_FOR_PHARMA_VIGILANCE":
      return { ...state, fetchingAdverseEvents: false, selectedAdverseEvent: action.payload }
    case "UPDATING_SELECTED_ADVERSE_EVENT_FOR_PHARMA_VIGILANCE":
      return { ...state, editingAdverseEvent: true}
    case "UPDATE_SELECTED_ADVERSE_EVENT_FOR_PHARMA_VIGILANCE":
      let { adverseEvents } = state
      if (adverseEvents.length) {
        adverseEvents = resetArrayAfterUpdate(state.adverseEvents, action.payload)
      }
      return {
        ...state, editingAdverseEvent: false,
        selectedAdverseEvent: action.payload,
        adverseEvents,
       }
     case "FETCHING_ADVERSE_EVENT_HISTORY_FOR_PHARMA_VIGILANCE":
       return { ...state, fetchingAdverseEventHistory: true }
     case "SET_ADVERSE_EVENT_HISTORY_FOR_PHARMA_VIGILANCE":
       return {
         ...state,
         fetchingAdverseEventHistory: false,
         adverseEventHistory: action.payload,
       }
    default:
      return state
  }
}

const fetchingAdverseEventsForPharmaVigilance = () => {
  return { type: "FETCHING_ADVERSE_EVENTS_FOR_PHARMA_VIGILANCE"}
}

const setAdverseEventsForPharmaVigilance = (adverseEvents) => {
  return { type: "SET_ADVERSE_EVENTS_FOR_PHARMA_VIGILANCE", payload: adverseEvents }
}

export const setSelectedAdverseEventForPharmaVigilance = (adverseEvent) => {
  return { type: "SET_SELECTED_ADVERSE_EVENT_FOR_PHARMA_VIGILANCE", payload: adverseEvent }
}

export const getAdverseEvents = (alert) => {
  return (dispatch) => {
    dispatch(fetchingAdverseEventsForPharmaVigilance())

    axios({
      method: 'GET',
      url: `${getServerUrl()}/cefiderocol-adverse-events/region/`,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => dispatch(setAdverseEventsForPharmaVigilance(response.data)))
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'retrieving the adverse drug effects from the server', dispatch)
      dispatch(setAdverseEventsForPharmaVigilance([]))

      if (alert && message) {
        alert.show(message)
      }
    })
  }
}

export const getAdverseEvent = (id, alert) => {
  return (dispatch) => {
    dispatch(fetchingAdverseEventsForPharmaVigilance())

    axios({
      method: 'GET',
      url: `${getServerUrl()}/cefiderocol-adverse-events/${id}/for_pharma_vigilance/`,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => dispatch(setSelectedAdverseEventForPharmaVigilance(response.data)))
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'retrieving the adverse drug effect from the server', dispatch)
      dispatch(setSelectedAdverseEventForPharmaVigilance(null))

      if (alert && message) {
        alert.show(message)
      }
    })
  }
}

const updatingAdverseEvent = () => {
  return { type: 'UPDATING_SELECTED_ADVERSE_EVENT_FOR_PHARMA_VIGILANCE'  }
}

export const updateAdverseEvent = (adverseEvent) => {
  return { type: 'UPDATE_SELECTED_ADVERSE_EVENT_FOR_PHARMA_VIGILANCE', payload: adverseEvent }
}

const resetArrayAfterUpdate = (array, updatedItem, param = 'url') => {
  const index = array.findIndex(element => element[param] === updatedItem[param])
  return [
    ...array.slice(0, index),
    updatedItem,
    ...array.slice(index + 1)
  ]
}

export const patchAdverseEvent = (adverseEvent, data, alert) => {
  return (dispatch) => {
    dispatch(updatingAdverseEvent())

    axios({
      method: 'PATCH',
      url: adverseEvent.url,
      data,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => {
      dispatch(updateAdverseEvent({
        ...adverseEvent,
        ...response.data,
      }))
    })
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'updating the adverse drug effect on the server', dispatch)
      
      if (alert && message) {
        alert.show(message)
      }
    })
  }
}


const fetchingAdverseEventHistoryForPharmaVigilance = () => {
  return { type: "FETCHING_ADVERSE_EVENT_HISTORY_FOR_PHARMA_VIGILANCE"}
}

export const setAdverseEventHistory = (adverseEventHistory) => {
  return {
    type: 'SET_ADVERSE_EVENT_HISTORY_FOR_PHARMA_VIGILANCE',
    payload: adverseEventHistory,
  }
}

export const getAdverseEventHistory = (id, alert) => {
  return (dispatch) => {
    dispatch(fetchingAdverseEventHistoryForPharmaVigilance())

    axios({
      method: 'GET',
      url: `${getServerUrl()}/cefiderocol-adverse-events/${id}/get_history/`,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => {
      dispatch(setAdverseEventHistory(response.data))
    })
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, `gathering the adverse drug effect's history`, dispatch)

      if (alert && message) {
        alert.show(message)
      }
    })
  }
}
